import { Component } from '@angular/core';

@Component({
    selector: 'app-warranty-terms',
    templateUrl: './warranty-terms.component.html',
    styleUrls: ['./warranty-terms.component.scss'],
    standalone: false
})
export class WarrantyTermsComponent {

}
